import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import authSelectors from '../../store/auth/authSelectors'
import { APP_MODE } from '../../sharedTypes'

const FULL_ORG_ONLY_PATHS = [
  '/cases/overview',
  '/cases/investigation',
  '/cases/timeline',
  '/cases/attachments',
  '/cases/export',
  '/cases/resolve',
  '/cases/updates',
]

const RequireFullOrg: React.FC = () => {
  const appMode = useSelector(authSelectors.userOrganizationType)
  const location = useLocation()

  const isFullOrgOnlyPath = FULL_ORG_ONLY_PATHS.some(path =>
    location.pathname.startsWith(path),
  )

  if (appMode !== APP_MODE.full && isFullOrgOnlyPath) {
    return <Navigate to='/cases/initialReport' replace />
  }

  return <Outlet />
}

export default RequireFullOrg
